import clientRender from '../clientRender';

import { routes } from './components/app/app';

clientRender(routes);
